import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PublicAuths = () => {
    const isAuthenticated = () => {
        const user = JSON.parse(localStorage.getItem('login'));
        if(user) return true
        return false
    };
    return isAuthenticated() ? <Navigate to="/vendorDetails" /> : <Outlet />;
};

export default PublicAuths;